// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"0eb574e1","237":"0eb574e1","244":"a08de452","383":"a08de452","413":"a08de452","494":"a08de452","575":"a08de452","970":"cae1f540","994":"a08de452"}[chunkId] + ".chunk.css";
};